module.exports = __webpack_public_path__ + "media/images/mobile-screenshot-264b629551201765d8d6ab8979e97f99.jpg";